import { AnimatePresence, motion } from "framer-motion"
import { Outlet } from 'react-router-dom'
import { AnimatedTitle } from "./AnimatedTitle"



type Props = {}

const AuthLayout = (props: Props) => {
    return (
        <div className="min-h-[98vh] flex items-center justify-center bg-login-hd" style={{ backgroundRepeat: "no-repeat", backgroundSize: "100% 100%" }} >
            <div className="w-full md:flex  " >
                <motion.div
                    className="md:w-1/2 flex justify-center items-center "
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.3, ease: "easeOut" }}
                >
                    <div className=" flex items-center justify-center p-8">
                        {/* <motion.div
                            className="relative"
                            initial={{ scale: 0.9, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            transition={{ delay: 0.3, duration: 0.3, ease: "easeOut" }}
                        >
                            <div>GEC Consumer</div>
                        </motion.div> */}
                        <AnimatedTitle />
                    </div>
                </motion.div>
                <motion.div
                    className="md:w-1/2  flex items-center justify-center bg-gradient-to-br from-theam-blue-700 to-theam-blue-800 py-16 rounded-tl-xl rounded-bl-xl "
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.3, ease: "easeOut" }}
                >
                    <div className="w-full max-w-md">
                        <AnimatePresence mode="wait">
                            <motion.div
                                key="login"
                                initial={{ opacity: 0, x: -20 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: 20 }}
                                transition={{ duration: 0.5, ease: "easeInOut" }}
                            >

                                <Outlet />

                            </motion.div>
                        </AnimatePresence>
                    </div>
                </motion.div>
            </div>
        </div>
    )
}

export default AuthLayout